import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap is imported
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const QuyenSD = () => {
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [employees, setEmployees] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  
  // Updated permissions list based on Admin.js structure
  const permissionsList = [
    // System & Admin Access
    'admin.access',
    'system.access',
    'system.network.manage',
    
    // Dashboard & Analytics
    'dashboard.view',
    'cake.dashboard.view',
    'report.view',
    'report.sales.view',
    'report.inventory.view',
    
    // Product Management (hierarchical)
    'product.manage',
    'product.create',
    'product.edit',
    'product.price.manage',
    'product.price.schedule',
    
    // Inventory Management (hierarchical)
    'inventory.manage',
    'inventory.view',
    'inventory.import.create',
    'inventory.transfer.create',
    'inventory.transfer.view',
    'inventory.transfer.approve',
    'inventory.audit.manage',
    
    // HR Management
    'user.manage',
    'hr.shift.manage',
    'hr.attendance.view',
    'hr.dashboard',
    
    // Production Management
    'production.materials.manage',
    'production.quota.manage',
    
    // Payment & System Settings
    'payment.qr.manage',
    'payment.rounding.manage',
    
    // Permission Management
    'permission.manage'
  ];

  const permissionLabels = {
    // System & Admin Access
    'admin.access': 'Truy cập Admin',
    'system.access': 'Truy cập Hệ thống',
    'system.network.manage': 'Quản lý Mạng & IP',
    
    // Dashboard & Analytics
    'dashboard.view': 'Xem Dashboard',
    'cake.dashboard.view': 'Xem Dashboard bánh kem',
    
    'report.view': 'Báo cáo trung thu',
    'report.sales.view': 'Doanh số trung thu',
    'report.inventory.view': 'Tồn kho trung thu',
    
    // Product Management
    'product.manage': 'Quản lý Sản phẩm (Tổng quát)',
    'product.create': 'Tạo Sản phẩm mới',
    'product.edit': 'Chỉnh sửa Sản phẩm',
    'product.price.manage': 'Quản lý Giá sản phẩm',
    'product.price.schedule': 'Lên lịch Cập nhật giá',
    
    // Inventory Management
    'inventory.manage': 'Quản lý Kho (Tổng quát)',
    'inventory.view': 'Xem Tồn kho',
    'inventory.import.create': 'Tạo Phiếu nhập admin',
    'inventory.transfer.create': 'Tạo Điều chuyển',
    'inventory.transfer.view': 'Xem Điều chuyển',
    'inventory.transfer.approve': 'Duyệt Điều chuyển',
    'inventory.audit.manage': 'Quản lý Kiểm kê',
    
    // HR Management
    'user.manage': 'Quản lý Người dùng',
    'hr.shift.manage': 'Quản lý Ca làm việc',
    'hr.attendance.view': 'Xem Chấm công',
    'hr.dashboard': 'Dashboard cham cong',
    
    // Production Management
    'production.materials.manage': 'Quản lý Nguyên liệu',
    'production.quota.manage': 'Quản lý Định mức',
    
    // Payment & System Settings
    'payment.qr.manage': 'Quản lý QR Thanh toán',
    'payment.rounding.manage': 'Cài đặt Làm tròn',

    // Sales & Bill Management
    'sales.view': 'Xem Doanh số',
    'bill.view': 'Xem Hóa đơn',
    'bill.manage': 'Quản lý Hóa đơn (Tổng quát)',
    'bill.create': 'Tạo Hóa đơn',
    'bill.edit': 'Chỉnh sửa Hóa đơn',
    'bill.delete': 'Xóa Hóa đơn',
    
    // Permission Management
    'permission.manage': 'Quản lý Quyền'
  };

  // Permission categories for better UI organization
  const permissionCategories = {
    'Hệ thống & Admin': [
      'admin.access',
      'system.access',
      'system.network.manage'
    ],
    'Dashboard & Báo cáo': [
      'dashboard.view',
      'cake.dashboard.view',
      'report.view',
      'report.sales.view',
      'report.inventory.view'
    ],
    'Quản lý Sản phẩm': [
      'product.manage',
      'product.create',
      'product.edit',
      'product.price.manage',
      'product.price.schedule'
    ],
    'Quản lý Kho': [
      'inventory.manage',
      'inventory.view',
      'inventory.import.create',
      'inventory.transfer.create',
      'inventory.transfer.view',
      'inventory.transfer.approve',
      'inventory.audit.manage'
    ],
    'Nhân sự': [
      'user.manage',
      'hr.shift.manage',
      'hr.attendance.view',
      'hr.dashboard'
    ],
    'Sản xuất': [
      'production.materials.manage',
      'production.quota.manage'
    ],
    'Bán hàng & Hóa đơn': [
      'sales.view',
      'bill.view',
      'bill.manage',
      'bill.create',
      'bill.edit',
      'bill.delete'
    ],
    'Thanh toán & Cài đặt': [
      'payment.qr.manage',
      'payment.rounding.manage'
    ],
    'Phân quyền': [
      'permission.manage'
    ]
  };

  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalEmployees, setModalEmployees] = useState([]);
  const [employeeNames, setEmployeeNames] = useState({}); // New state for employee names
  const [editingEmployee, setEditingEmployee] = useState(null);
  const [editingPermissions, setEditingPermissions] = useState([]);

  // Fetch departments
  const fetchDepartments = async () => {
    setLoading(true);
    try {
      const res = await fetch('https://doticom.vn:3000/api/departments');
      const data = await res.json();
      if (data.success) {
        setDepartments(data.data);
      }
    } catch (err) {
      toast.error('Lỗi khi tải danh sách phòng ban');
    }
    setLoading(false);
  };

  // Fetch employees by department
  const fetchEmployees = async (maPB) => {
    if (!maPB) return;
    setLoading(true);
    try {
      const res = await fetch(`https://doticom.vn:3000/api/departments/${maPB}/employees`);
      const data = await res.json();
      if (data.success) {
        setEmployees(data.data);
      }
    } catch (err) {
      toast.error('Lỗi khi tải danh sách nhân viên');
    }
    setLoading(false);
  };

  // Fetch permissions for modal
  const fetchPermissionsForModal = async (maPB) => {
    if (!maPB) return;
    setLoading(true);
    try {
      // Fetch permissions
      const permRes = await fetch(`https://doticom.vn:3000/api/user-permissions?MaPB=${maPB}`);
      const permData = await permRes.json();
      
      // Fetch employees for names
      const empRes = await fetch(`https://doticom.vn:3000/api/departments/${maPB}/employees`);
      const empData = await empRes.json();
      
      if (permData.success && empData.success) {
        setModalEmployees(permData.data);
        // Create name mapping
        const names = {};
        empData.data.forEach(emp => {
          names[emp.MaNV] = emp.TenKhongDau || emp.MaNV;
        });
        setEmployeeNames(names);
      }
    } catch (err) {
      toast.error('Lỗi khi tải quyền');
    }
    setLoading(false);
  };

  useEffect(() => { fetchDepartments(); }, []);

  useEffect(() => { fetchEmployees(selectedDepartment); }, [selectedDepartment]);

  useEffect(() => { if (showModal) fetchPermissionsForModal(selectedDepartment); }, [showModal, selectedDepartment]);

  // Handle employee selection
  const handleEmployeeSelect = (maNV) => {
    setSelectedEmployees(prev =>
      prev.includes(maNV) ? prev.filter(id => id !== maNV) : [...prev, maNV]
    );
  };

  // Select all employees
  const selectAllEmployees = () => {
    setSelectedEmployees(employees.map(emp => emp.MaNV));
  };

  // Deselect all employees
  const deselectAllEmployees = () => {
    setSelectedEmployees([]);
  };

  // Handle permission selection
  const handlePermissionSelect = (perm) => {
    setSelectedPermissions(prev =>
      prev.includes(perm) ? prev.filter(p => p !== perm) : [...prev, perm]
    );
  };

  // Update permissions for selected employees
  const updatePermissions = async () => {
    if (selectedEmployees.length === 0 || selectedPermissions.length === 0) {
      toast.warning('Vui lòng chọn nhân viên và quyền');
      return;
    }
    try {
      const res = await fetch('https://doticom.vn:3000/api/user-permissions', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          MaNVs: selectedEmployees,
          permissions: selectedPermissions
        })
      });
      const data = await res.json();
      if (data.success) {
        toast.success(data.message);
        setSelectedEmployees([]);
        setSelectedPermissions([]);
      }
    } catch (err) {
      toast.error('Lỗi khi cập nhật quyền');
    }
  };

  // Edit permissions for a single employee
  const editPermissions = (emp) => {
    setEditingEmployee(emp.MaNV);
    setEditingPermissions(emp.permissions || []);
  };

  // Save edited permissions
  const saveEditedPermissions = async () => {
    try {
      const res = await fetch('https://doticom.vn:3000/api/user-permissions', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          MaNV: editingEmployee,
          permissions: editingPermissions
        })
      });
      const data = await res.json();
      if (data.success) {
        toast.success(data.message);
        setEditingEmployee(null);
        fetchPermissionsForModal(selectedDepartment);
      }
    } catch (err) {
      toast.error('Lỗi khi cập nhật quyền');
    }
  };

  // Delete all permissions for an employee
  const deletePermissions = async (maNV) => {
    try {
      const res = await fetch(`https://doticom.vn:3000/api/user-permissions/${maNV}`, { method: 'DELETE' });
      const data = await res.json();
      if (data.success) {
        toast.success(data.message);
        fetchPermissionsForModal(selectedDepartment);
      }
    } catch (err) {
      toast.error('Lỗi khi xóa quyền');
    }
  };

  return (
    <div class="admin-main" style={{marginLeft: 0}}>
      <header className="admin-header">
        <div className="header-left">
          <h1>Quản Lý Quyền</h1>
          <p>Phân quyền cho nhân viên theo phòng ban</p>
        </div>
      </header>

      <div className="content-section">
        {message && <div className="alert alert-info">{message}</div>}

        {/* Button to open modal */}
        <div className="text-center mb-4">
          <button className="btn btn-info" onClick={() => setShowModal(true)}>Xem & Chỉnh Sửa Quyền Hiện Có</button>
        </div>

        {/* Department Selection */}
        <div className="card mb-4">
          <div className="card-header">
            <h3>Chọn Phòng Ban</h3>
          </div>
          <div className="card-body">
            <div className="form-group">
              <label>Phòng Ban</label>
              <select
                className="form-control"
                value={selectedDepartment}
                onChange={(e) => setSelectedDepartment(e.target.value)}
              >
                <option value="">Chọn phòng ban</option>
                {departments.map(dep => (
                  <option key={dep.MaPB} value={dep.MaPB}>{dep.TenBoPhan}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Employee Selection */}
        {selectedDepartment && (
          <div className="card mb-4">
            <div className="card-header">
              <h3>Chọn Nhân Viên</h3>
            </div>
            <div className="card-body">
              <div className="mb-3">
                <button className="btn btn-secondary me-2" onClick={selectAllEmployees}>Chọn Tất Cả</button>
                <button className="btn btn-outline-secondary" onClick={deselectAllEmployees}>Bỏ Chọn Tất Cả</button>
              </div>
              <div className="row">
                {employees.map(emp => (
                  <div key={emp.MaNV} className="col-md-4 mb-2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={emp.MaNV}
                        checked={selectedEmployees.includes(emp.MaNV)}
                        onChange={() => handleEmployeeSelect(emp.MaNV)}
                      />
                      <label className="form-check-label" htmlFor={emp.MaNV}>
                        {emp.TenKhongDau || emp.MaNV}
                      </label>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Permission Selection */}
        <div className="card mb-4">
          <div className="card-header">
            <h3>Chọn Quyền</h3>
          </div>
          <div className="card-body">
            {Object.entries(permissionCategories).map(([category, perms]) => (
              <div key={category} className="mb-4">
                <h5 className="text-primary border-bottom pb-2">{category}</h5>
                <div className="row">
                  {perms.map(perm => (
                    <div key={perm} className="col-md-6 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={perm}
                          checked={selectedPermissions.includes(perm)}
                          onChange={() => handlePermissionSelect(perm)}
                        />
                        <label className="form-check-label" htmlFor={perm}>
                          <span className="fw-bold">{permissionLabels[perm]}</span>
                          <br />
                          <small className="text-muted">{perm}</small>
                        </label>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Update Button */}
        <div className="text-center">
          <button className="btn btn-primary" onClick={updatePermissions} disabled={loading}>
            {loading ? 'Đang cập nhật...' : 'Cập Nhật Quyền'}
          </button>
        </div>
      </div>

      {/* Modal for viewing and editing permissions */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Xem & Chỉnh Sửa Quyền</h3>
              <button className="modal-close" onClick={() => setShowModal(false)}>&times;</button>
            </div>
            <div className="modal-body">
              <div className="form-group mb-3">
                <label>Lọc Theo Phòng Ban</label>
                <select
                  className="form-control"
                  value={selectedDepartment}
                  onChange={(e) => setSelectedDepartment(e.target.value)}
                >
                  <option value="">Chọn phòng ban</option>
                  {departments.map(dep => (
                    <option key={dep.MaPB} value={dep.MaPB}>{dep.TenBoPhan}</option>
                  ))}
                </select>
              </div>
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>MaNV</th>
                    <th>HoVaTen</th>
                    <th>Quyền</th>
                    <th>Hành Động</th>
                  </tr>
                </thead>
                <tbody>
                  {modalEmployees.map(emp => (
                    <tr key={emp.MaNV}>
                      <td>{emp.MaNV}</td>
                      <td>{employeeNames[emp.MaNV] || emp.MaNV}</td>
                      <td>
                        {editingEmployee === emp.MaNV ? (
                          <div>
                            {Object.entries(permissionCategories).map(([category, perms]) => (
                              <div key={category} className="mb-3">
                                <h6 className="text-primary">{category}</h6>
                                {perms.map(perm => (
                                  <div key={perm} className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={`edit-${perm}`}
                                      checked={editingPermissions.includes(perm)}
                                      onChange={() => setEditingPermissions(prev =>
                                        prev.includes(perm) ? prev.filter(p => p !== perm) : [...prev, perm]
                                      )}
                                    />
                                    <label className="form-check-label" htmlFor={`edit-${perm}`}>
                                      <small>{permissionLabels[perm] || perm}</small>
                                    </label>
                                  </div>
                                ))}
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div>
                            {emp.permissions.map(p => (
                              <span key={p} className="badge bg-secondary me-1 mb-1">
                                {permissionLabels[p] || p}
                              </span>
                            ))}
                          </div>
                        )}
                      </td>
                      <td>
                        {editingEmployee === emp.MaNV ? (
                          <>
                            <button className="btn btn-sm btn-success me-2" onClick={saveEditedPermissions}>Lưu</button>
                            <button className="btn btn-sm btn-secondary" onClick={() => setEditingEmployee(null)}>Hủy</button>
                          </>
                        ) : (
                          <>
                            <button className="btn btn-sm btn-warning me-2" onClick={() => editPermissions(emp)}>Sửa</button>
                            <button className="btn btn-sm btn-danger" onClick={() => deletePermissions(emp.MaNV)}>Xóa Tất Cả</button>
                          </>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default QuyenSD;


